import type { PmcApiResponse, PmcConfig, PmcProfile } from '@prime-types/pmcstarter'

/**
 * PmcBridge to centralize all exchanges with the PMC API
 */
export default class PmcBridge {
	/**
	 * Get the PMC profile from API
	 * @async
	 * @returns Return the JSON of the PMC profile, by field or not, with a Promise
	 */
	async getProfile(): Promise<PmcProfile | false> {
		return new Promise((resolve, reject) => {
			window.pmcstarter(async (myPmc) => {
				try {
					const response = await myPmc.getProfile()
					resolve(response)
				} catch (error) {
					console.warn('PmcBridge::getProfile error', error)
					reject(error)
				}
			})
		})
	}

	/**
	 * Update the PMC profile on the API
	 * @async
	 * @param options Options
	 * @param options.datas New profile data to update
	 * @returns Return the JSON object of the response with a Promise
	 */
	async updateProfile({ datas }: { datas: object }): Promise<PmcApiResponse | Error> {
		return new Promise((resolve, reject) => {
			window.pmcstarter(async (myPmc) => {
				try {
					const response = await myPmc.apiClient.updateProfile(datas)
					await myPmc.refreshProfile()
					resolve(response)
				} catch (error) {
					console.warn('PmcBridge::updateProfile error', error)
					reject(error)
				}
			})
		})
	}

	/**
	 * Check if the user has the granted role and is connected
	 * Inactive user has the alive role
	 * @async
	 * @returns User is granted
	 */
	async isGranted(): Promise<boolean | Error> {
		return new Promise((resolve, reject) => {
			window.pmcstarter(async (myPmc) => {
				try {
					const roles = (await myPmc.getRoles()) || []
					const grantedRoles = roles.some((role) => ['ADMIN', 'ALIVE'].includes(role))

					resolve(grantedRoles)
				} catch (error) {
					console.warn('PmcBridge::isGranted error', error)
					reject(error)
				}
			})
		})
	}

	/**
	 * Get config data
	 * @async
	 * @returns Config data
	 */
	async getConfig(): Promise<PmcConfig> {
		return new Promise((resolve) => {
			window.pmcstarter((myPmc) => resolve(myPmc.config))
		})
	}

	/**
	 * Get PMC domain
	 * @async
	 * @returns Return the PMC domain with a Promise
	 */
	async getPmcDomain(): Promise<string> {
		return new Promise((resolve) => {
			window.pmcstarter(async (myPmc) => resolve(myPmc.pmcDomain))
		})
	}
}
